
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["success-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 0c10.493 0 19 8.507 19 19s-8.507 19-19 19S0 29.493 0 19 8.507 0 19 0zm9.707 12.293a1 1 0 00-1.414 0L16 23.585l-5.293-5.292-.094-.083a1 1 0 00-1.32 1.497l6 6 .094.083a1 1 0 001.32-.083l12-12 .083-.094a1 1 0 00-.083-1.32z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    